/**
 * Carousel configurations
 *
 * ProductDetails: For Product Details carousel
 * TODO: Inspirations Carousel
 * TODO: Recommendations / Product Tiles Carousel
 */

module.exports = {
    productDetails: {
        dots: true,
        infinite: true,
        speed: 600,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1
    },
    inspirations: {
        dots: false,
        infinite: true,
        speed: 600,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000
    },
    recommendations: {
        dots: false,
        infinite: true,
        speed: 600,
        variableWidth: false,
        slidesToShow: 2,
        slidesToScroll: 2
    },
    generic: {
        dots: false,
        infinite: true,
        speed: 600,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    }
};
